import { useState } from 'react';
import { getCurrentPermissions } from '../AppShell/Authentication/AuthorisationAsync';
import { AuthState } from '../AppShell/Authentication/AuthorisationModels';
import {
    AllApplicationPermissions,
    getAuthorisationPermissions,
    setAuthorisationPermissions
} from '../Config/PermissionConfig';

export function isUserAuthorised(code: AllApplicationPermissions | AllApplicationPermissions[]): boolean {
    if (Array.isArray(code)) {
        let isAuthorised = true;

        code.forEach(targetCode => {
            const permissionState = getAuthorisationPermissions().find(it => it.definitionCode === targetCode);
            if (permissionState) {
                if (permissionState.state !== AuthState.Allowed) isAuthorised = false;
            } else {
                isAuthorised = false;
                console.warn('Unknown permission code requested - code: ', code);
            }
        });

        return isAuthorised;
    } else {
        const permissionState = getAuthorisationPermissions().find(it => it.definitionCode === code);
        if (permissionState) return permissionState.state === AuthState.Allowed;
    }

    console.warn('Unknown permission code requested - code: ', code);
    return false;
}

export enum LoadingStatus {
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error'
}

export function usePermissionLoader() {
    const [permissionStatus, setPermissionStatus] = useState<LoadingStatus>(LoadingStatus.Loading);

    async function loadPermissions() {
        try {
            const permissions = await getCurrentPermissions();
            setAuthorisationPermissions(permissions);
            setPermissionStatus(LoadingStatus.Loaded);
        } catch (err) {
            setPermissionStatus(LoadingStatus.Error);
        }
    }

    return {
        permissionStatus,
        loadPermissions
    };
}
